/**
 * Coerces a data-bound value (typically a string) to a boolean.
 * @param {?} value
 * @return {?}
 */
export function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false' && "" + value !== '';
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/core/coersion/boolean-property.js
// module id = 1350
// module chunks = 31